import { CentralSystem as ApiCentralSystem } from '@infuse/api/e-connector/central-system';
import { CentralSystem, ConnectionType, OcppVersion } from './model';
import { enumFromStringValue } from '@infuse/utils';

export const mapToDomain = (apiCentralSystem: ApiCentralSystem): CentralSystem => {
  return {
    id: apiCentralSystem.id,
    name: apiCentralSystem.name,
    type: enumFromStringValue(ConnectionType, apiCentralSystem.type),
    ocppVersion: enumFromStringValue(OcppVersion, apiCentralSystem.ocppVersion),
    uri: apiCentralSystem.uri,
    readonly: apiCentralSystem.readOnly,
    visibility: apiCentralSystem.visibility
  };
};

export const mapToApi = (centralSystem: CentralSystem): ApiCentralSystem => {
  return {
    id: centralSystem.id,
    name: centralSystem.name,
    type: centralSystem.type,
    ocppVersion: centralSystem.ocppVersion,
    uri: centralSystem.uri,
    readOnly: centralSystem.readonly,
    visibility: centralSystem.visibility
  };
};
